import { useEffect } from 'react';
import { useCertStore } from '../stores/certStore';

/**
 * Sets the document title dynamically based on the current page and active certification.
 * Format: "PageTitle -- CertName | CloudMaster" or "PageTitle | CloudMaster" if no cert is active.
 */
export function useDocumentTitle(pageTitle: string) {
  const certName = useCertStore((s) => s.certName);

  useEffect(() => {
    document.title = certName
      ? `${pageTitle} \u2014 ${certName} | CloudMaster`
      : `${pageTitle} | CloudMaster`;
  }, [pageTitle, certName]);
}
